import Joi from 'joi';
import type { ExtractValues, SchemaOf } from '../helpers';
import { objectSchemaOf } from '../helpers';

const strategies = [
  'broad-vocabulary',
  'narrow-vocabulary',
  'fastest-engine',
  'highest-quality',
  'fastest-with-threshold',
] as const;

export type Strategy = ExtractValues<typeof strategies>;

export const strategySchema = Joi.string().valid(...strategies);

export interface IConfigureParams {
  resultIsFinalTimeout?: number;
  expectedResults?: string[];
  strategy?: Strategy;
  questionId?: string;
}

export const configureParamsSchemaMap: SchemaOf<IConfigureParams> = {
  resultIsFinalTimeout: Joi.number().optional(),
  expectedResults: Joi.array().items(Joi.string().not('')).optional(),
  strategy: strategySchema.optional(),
  questionId: Joi.string().optional(),
};

export const configureParamsSchema = objectSchemaOf<IConfigureParams>(
  configureParamsSchemaMap
);
